<div class="form-group">
    <label class="ui-checkbox input-label">
    <input class="form-control" name="requiredTotalPercentage" type="checkbox" value="{{fieldOptions.validate.requiredTotalPercentage}}"
           [(ngModel)]="fieldOptions.validate.requiredTotalPercentage">
    <span><b>Total percentage 100% required in Grid</b></span>
  </label>
</div>